import templateUrl from './claim-timer.html'
import './claim-timer.scss'

const ClaimTimerComponent = {
  bindings: {
    // UTC datetime string from BE (claim.expiredAt). Null / undefined => no timer.
    expiresAt: '<'
  },
  templateUrl,
  controller: class ClaimTimer {
    constructor ($interval, moment, UserService) {
      'ngInject'
      this._identify = 'ClaimTimerComponent'
      this.$interval = $interval
      this.moment = moment
      this.UserService = UserService
      this.remaining = null
      this.isExpired = false
    }

    $onInit () {
      this.tick()
      this.timer = this.$interval(() => this.tick(), 1000)
    }

    $onDestroy () {
      if (this.timer) {
        this.$interval.cancel(this.timer)
      }
    }

    // Experts only - clients never have an engagement claim / timer.
    // Show only while there is a future expiry. When expiresAt is cleared
    // (BE nulls it after the first public comment) or the deadline passes,
    // the widget hides itself. FE never unclaims - BE does that server-side.
    get hasTimer () {
      return this.UserService.isExpert() && !!this.expiresAt && !this.isExpired
    }

    tick () {
      if (!this.expiresAt) {
        this.remaining = null
        this.isExpired = false
        return
      }

      // BE format: "YYYY-MM-DD HH:MM:SS UTC" (e.g. "2026-07-16 07:27:45 UTC")
      const diffMs = this.moment.utc(this.expiresAt, 'YYYY-MM-DD HH:mm:ss [UTC]').diff(this.moment.utc())

      if (diffMs <= 0) {
        this.remaining = null
        this.isExpired = true
        return
      }

      this.isExpired = false
      const duration = this.moment.duration(diffMs)
      this.remaining = {
        hours: Math.floor(duration.asHours()),
        minutes: duration.minutes(),
        seconds: duration.seconds()
      }
    }

    get formatted () {
      if (!this.remaining) {
        return null
      }
      const pad = n => String(n).padStart(2, '0')
      return `${pad(this.remaining.hours)}:${pad(this.remaining.minutes)}:${pad(this.remaining.seconds)}`
    }
  }
}

export default ClaimTimerComponent
